import FetchUtils from '../utils/fetch.utils';

export default class CommissionService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_COMISSIONS}/api/commission`;

  static get = async params => {
    return FetchUtils.get(
      CommissionService.BASE_URL + FetchUtils.getQueryParams(params),
    );
  };

  static calculate = async params => {
    return FetchUtils.post(
      CommissionService.BASE_URL + FetchUtils.getQueryParams(params),
      { ...params },
    );
  };
}
